export default function (permissions, resource) {
  for (let i = 0; i < permissions.length; i++) {
    if (permissions[i] === `${resource}:*,u:*`) {
      return true;
    }
  }
  return false;
}
